import EventDTO from '../models/event';
import { OrderDTO, OrderItemData } from '../models/order';
import { formatCurrency } from './shared';

const generateWhatsappMessage = (event: EventDTO, order: OrderDTO, orderItems: OrderItemData[], totalToPay: number) => {
  const buyerName = `${orderItems[0].name} ${orderItems[0].last_name}`;

  return `Hola 👋
Quiero pagar por transferencia mis entradas para:

🎟 Evento: *${event.name}*
👤 Comprador: *${buyerName}*
🧾 Orden: *${order.display_id}*
💰 Total: *${formatCurrency(totalToPay)}*

¿Me pasás los datos para hacer la transferencia?
Gracias 🙌`;
};

export default generateWhatsappMessage;
